import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../constants/common'
import { useBeforeUnload, useBlockNavigation } from '../../../hooks'
import { FormModalConfirmation } from '../../Form'

function WidgetFormContainer({
  Confirmation = FormModalConfirmation,
  children,
  confirmationProps = EMPTY_OBJECT,
  isCloseConfirm,
  modal,
  setCloseConfirm,
  onClose,
  onCloseConfirm,
  onSubmitConfirm,
}) {
  const { dirty, values } = useFormikContext()

  useBeforeUnload(dirty, true)
  useBlockNavigation(dirty)

  function handleConfirmationCancel() {
    onCloseConfirm?.()
    setCloseConfirm(false)
  }

  function handleConfirmationSubmit(confirmationValue) {
    if (onSubmitConfirm) {
      onSubmitConfirm(values, confirmationValue)
    } else {
      onClose()
    }
  }

  return (
    <>
      {modal}
      {children}
      {isCloseConfirm ? (
        <Confirmation
          {...confirmationProps}
          onCancel={handleConfirmationCancel}
          onSubmit={handleConfirmationSubmit}
        />
      ) : null}
    </>
  )
}

export default WidgetFormContainer
